export enum BookAppointmentUniqueKeyEnum {
    INDIVIDUAL_THERAPY = "individualTherapyChoiceV1",
    COUPLES_THERAPY = "couplesTherapyChoiceV1",
    FAMILY_THERAPY = "familyTherapyChoiceV1",
    GROUP_THERAPY = "groupTherapyChoiceV1",
    PSYCHIATRY_THERAPY = "psychiatryTherapyChoiceV1",
    ASSESMENT_THERAPY = "autismAssessmentTherapyChoiceV1",
}
